export default {
  path: '/trade/detail',
  mapPath: '/trade/detail',
  component: require('./index').default,
  props: true,
  parent: 'root',
  meta: {
    title: '项目详情'
  },
  name: 'tradeDetail'
}
